module.exports = __webpack_public_path__ + "img/graphs_tree_illustration.cac3855a.jpg";